<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <HeaderOther
                :setTitle="
                    mode === 'forme'
                        ? 'ขอรับสำเนาข้อมูลส่วนบุคคล'
                        : 'ส่งสำเนาข้อมูลส่วนบุคคลให้ผู้ควบคุมข้อมูลอื่น'
                "
                :setHref="'privacysettings'"
                :showLogo="true"
            />
            <div class="main-container">
                <div class="page-container">
                    <div class="data-block">
                        <div class="label">ชื่อ</div>
                        <div class="data">{{ objData.firstName }}</div>
                    </div>
                    <div class="data-block">
                        <div class="label">นามสกุล</div>
                        <div class="data">{{ objData.lastName }}</div>
                    </div>
                    <div class="data-block">
                        <div class="label">เบอร์โทร</div>
                        <div class="data">{{ objData.contactNumber }}</div>
                    </div>
                    <div class="data-block">
                        <div class="label">วันเกิด</div>
                        <div class="data">{{ objData.birthDate }}</div>
                    </div>
                    <div class="data-block">
                        <div class="label">อายุ</div>
                        <div class="data">{{ objData.age }}</div>
                    </div>
                    <div class="data-block">
                        <div class="label">
                            กรอกอีเมลสำหรับรับข้อมูล <span>*</span>
                        </div>
                        <InputEmail
                            key="input-address-email"
                            v-model="objData.email"
                            class="input-field"
                            :input-lbl="lbl.shipping.email"
                            :input-max-length="60"
                            :is-show-error-lbl="false"
                            :error-info="errorInfo[0]"
                            :isShowLabel="false"
                        ></InputEmail>
                    </div>
                    <div class="data-block">
                        <div class="label">กำหนดรหัสผ่านในการเปิดไฟล์</div>
                        <label for="pin" class="block-container">
                            <div class="block">{{ pin[0] }}</div>
                            <div class="block">{{ pin[1] }}</div>
                            <div class="block">{{ pin[2] }}</div>
                            <div class="block">{{ pin[3] }}</div>
                        </label>
                        <input
                            id="pin"
                            v-model="pin"
                            maxlength="4"
                            type="tel"
                            class="hidden"
                            @input="onChangePin()"
                        />
                    </div>
                </div>
                <div class="button-footer">
                    <div
                        v-if="
                            errorInfo[0].isValid &&
                            objData.email &&
                            pin.length === 4
                        "
                        class="button-submit"
                        @click="openSubmit"
                    >
                        ยืนยัน
                    </div>
                    <div v-else class="button-submit disable">ยืนยัน</div>
                </div>
            </div>
        </div>
        <b-modal
            id="modalSubmit"
            no-close-on-esc
            no-close-on-backdrop
            modal-class="modal-submit"
            centered
            hide-header
            hide-footer
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="header">{{ confirmModal.header }}</div>
                    <!-- eslint-disable vue/no-v-html -->
                    <div class="modal-desc" v-html="confirmModal.body"></div>
                    <!--eslint-enable-->
                </div>
                <div class="modal-base-footer">
                    <div class="brown-btn" @click="submit()">
                        {{ confirmModal.ok }}
                    </div>
                    <div class="underline-btn" @click="hide()">
                        {{ confirmModal.cancel }}
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="modalSuccess"
            no-close-on-esc
            no-close-on-backdrop
            modal-class="modal-submit"
            centered
            hide-header
            hide-footer
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="header">{{ alertModal.header }}</div>
                    <!-- eslint-disable vue/no-v-html -->
                    <div class="modal-desc" v-html="alertModal.body"></div>
                    <!--eslint-enable-->
                </div>
                <div class="modal-base-footer">
                    <div class="brown-btn" @click="goto()">
                        {{ alertModal.ok }}
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import Mixin from "@/mixin/Mixin";
//component
import InputEmail from "@/components/Input/EditEmail.vue";
import HeaderOther from "@/components/Header/HeaderOther.vue";
//locale
import Locale from "@/helper/locale/locale.js";
//helper
import FormHelper from "@/helper/FormHelper.js";
import CacheHelper from "@/helper/CacheHelper";
import Account from "@/helper/AccountHelper.js";
//core
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";

export default {
    name: "RequestDocument",
    components: {
        InputEmail,
        HeaderOther,
    },
    mixins: [Mixin],
    data: function () {
        return {
            lbl: Locale.getLbl(),
            objData: {
                firstName: "",
                lastName: "",
                email: "",
                contactNumber: "",
                birthDate: "",
                age: "",
            },
            pin: "",
            errorInfo: [],
            cacheHelper: new CacheHelper(),
            mode: "forme",
            confirmModal: {
                header: "",
                body: "",
                ok: "",
                cancel: "",
            },
            alertModal: {
                header: "",
                body: "",
                ok: "",
            },
        };
    },
    created() {
        this.handleLoading(true);
        Promise.all([this.setData(), this.setBlob(), this.checkMode()]).then(
            () => {
                this.handleLoading(false);
            }
        );
    },
    methods: {
        checkMode() {
            return new Promise((resolve) => {
                this.mode = window.location.pathname.split("/")[2];
                resolve(this.mode);
            });
        },
        setData() {
            return new Promise((resolve, reject) => {
                this.errorInfo = FormHelper.genErrorInfo(1);
                BzbsApi.getProfile(this.cacheHelper.getCache("BzbsUser").token)
                    .then((response) => {
                        // console.log(response)
                        this.objData.firstName = response.data.FirstName;
                        this.objData.lastName = response.data.LastName;

                        if (this.mode === "forme") {
                            this.objData.email = response.data.Email;
                        }

                        this.objData.contactNumber =
                            response.data.Contact_Number;
                        var timestamp = response.data.BirthDate;
                        var monthString =
                            this.lbl.date.month_full[
                                moment.unix(timestamp).utc().format("M") - 1
                            ];
                        var yearString =
                            parseInt(moment.unix(timestamp).utc().format("Y")) +
                            543;
                        this.objData.birthDate =
                            moment.unix(timestamp).utc().format("D") +
                            " " +
                            monthString +
                            " " +
                            yearString;
                        resolve(response);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        onChangePin() {
            this.pin = this.pin.replace(/\D/g, "");
        },
        setBlob() {
            return new Promise((resolve, reject) => {
                BzbsOtp.getBlob()
                    .then((response) => {
                        this.objData.age = response.export_data_age_text;
                        // console.log(response);

                        if (this.mode === "forme") {
                            this.confirmModal.header =
                                response.confirmmodal_requestdocument.header;
                            this.confirmModal.body =
                                response.confirmmodal_requestdocument.body;
                            this.confirmModal.ok =
                                response.confirmmodal_requestdocument.ok;
                            this.confirmModal.cancel =
                                response.confirmmodal_requestdocument.cancel;

                            this.alertModal.header =
                                response.alertmodal_requestdocument.header;
                            this.alertModal.body =
                                response.alertmodal_requestdocument.body;
                            this.alertModal.ok =
                                response.alertmodal_requestdocument.ok;
                        } else {
                            this.confirmModal.header =
                                response.confirmmodal_requestdocument_forother.header;
                            this.confirmModal.body =
                                response.confirmmodal_requestdocument_forother.body;
                            this.confirmModal.ok =
                                response.confirmmodal_requestdocument_forother.ok;
                            this.confirmModal.cancel =
                                response.confirmmodal_requestdocument_forother.cancel;

                            this.alertModal.header =
                                response.alertmodal_requestdocument_forother.header;
                            this.alertModal.body =
                                response.alertmodal_requestdocument_forother.body;
                            this.alertModal.ok =
                                response.alertmodal_requestdocument_forother.ok;
                        }
                        resolve(this.objData.age);
                    })
                    .catch((err) => {
                        console.log("error ::::    ", err);
                        reject(err);
                    });
            });
        },
        openSubmit() {
            this.$bvModal.show("modalSubmit");
        },
        submit() {
            this.$bvModal.show("modalSuccess");
            this.$bvModal.hide("modalSubmit");
            const token = Account.getToken();
            var finalData = {
                email: this.objData.email,
                pin: this.pin,
            };
            BzbsOtp.apiRequestDocument(token, finalData).subscribe(
                (data) => {
                    console.log(data);
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        hide() {
            this.$bvModal.hide("modalSubmit");
            this.$bvModal.hide("modalSuccess");
        },
        goto() {
            this.$bvModal.hide("modalSuccess");
            this.$router.push("/privacysettings");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
@import "@/style/_mixin.scss";
$secondary-color: #4d341c;
.main-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 55px);
    .button-footer {
        margin-bottom: 40px;
        .button-submit {
            position: relative;
            z-index: 5;
            width: 90%;
            background-color: $color-text;
            border-radius: 25px;
            color: #fff;
            font-size: 16px;
            padding: 10px auto;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            height: 45px;
            font-family: "PromptSemiBold";

            &.disable {
                background-color: #c4c4c4;
                color: #666666;
            }
        }
    }
}
.page-container {
    padding: 0 20px;
    font-family: "PromptRegular";
    .data-block {
        margin-top: 15px;
        .label {
            margin-bottom: 10px;
            font-size: 14px;
            color: $color-text;
            span {
                color: #e1261c;
            }
        }
        .data {
            font-size: 16px;
            color: $color-text;
        }
        .input-field {
            z-index: 5;
        }
        .block-container {
            display: flex;
            margin-bottom: 20px;
            z-index: 5;
            position: relative;

            .block {
                background-color: #fff;
                border: 1px solid $color-text;
                border-radius: 10px;
                width: 35px;
                height: 45px;
                margin-right: 9px;
                color: #000;
                font-family: "PromptBold";
                font-size: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .hidden {
            width: 0;
            height: 0;
            position: fixed;
            bottom: 0;
            right: 0;
            border: none;
        }
    }
}

::v-deep #modalSubmit,
#modalSuccess {
    .modal-base {
        font-size: 23px;
        padding: 11px 6px;
        .modal-base-body {
            text-align: center;
            .header {
                display: flex;
                justify-content: center;
                color: $color-text;
                width: 100%;
                padding: 0;
                font-size: 18px;
                margin-bottom: 12px;
            }
            .modal-desc {
                color: $color-brown-800;
                padding: 0 50px;
                font-size: 16px;
            }
        }
        .modal-base-footer {
            margin-top: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .brown-btn {
                width: 100%;
                font-size: 16px;
            }
            .underline-btn {
                font-size: 16px;
                color: $color-text;
                margin-bottom: 5px;
            }
        }
    }
}
.wrapper-bg {
    padding: 0;
}
</style>
